export const restoreTrackedScrollPosition = (scrollArea, targetValue, onChange) => {
  if (!scrollArea) return () => {};

  const target = Math.max(0, Number(targetValue) || 0);
  const timeoutIds = [];
  let animationFrameId = 0;
  let disposed = false;
  let restoring = target > 0;

  const setScrollTop = value => {
    const previousBehavior = scrollArea.style.scrollBehavior;
    scrollArea.style.scrollBehavior = 'auto';
    scrollArea.scrollTop = value;
    scrollArea.style.scrollBehavior = previousBehavior;
  };

  const applyTarget = () => {
    if (disposed || !restoring || !scrollArea.isConnected) return;
    setScrollTop(target);
    if (Math.abs(scrollArea.scrollTop - target) <= 1) restoring = false;
  };

  const handleScroll = () => {
    if (restoring) {
      if (Math.abs(scrollArea.scrollTop - target) <= 1) restoring = false;
      return;
    }
    onChange(scrollArea.scrollTop);
  };

  applyTarget();
  animationFrameId = window.requestAnimationFrame(applyTarget);
  [60, 180, 360, 700, 1200].forEach(delay => {
    timeoutIds.push(window.setTimeout(applyTarget, delay));
  });
  timeoutIds.push(window.setTimeout(() => {
    restoring = false;
  }, 1300));

  scrollArea.addEventListener('scroll', handleScroll, { passive: true });

  return () => {
    disposed = true;
    window.cancelAnimationFrame(animationFrameId);
    timeoutIds.forEach(window.clearTimeout);
    scrollArea.removeEventListener('scroll', handleScroll);
  };
};
